import { useGetAuthenticatedUser } from "../../app/-components/use-authenticated-user"
import { Stack, Text } from "@mantine/core"
import { ChatDto } from "@/orval/gen/model"
import { PersonLink } from "@/routes/app/art/activities/-components/-tabs/CastsTab/person-links"
import { PersonNameWithUserNameFallback } from "./ChatListForCurrentUser/PersonNameWithUserNameFallback"

interface Props {
  chat: ChatDto
}

export function ChatName({ chat }: Props) {
  if (chat.chatType === "Direct") {
    return (
      <Text size="lg">
        <DirectChatName chat={chat} />
      </Text>
    )
  }
  return (
    <Stack gap={0} miw={0}>
      <Text size="lg" truncate>
        {chat.name}
      </Text>
      <Text c="dimmed" size="xs" truncate lineClamp={1}>
        {chat.description}
      </Text>
    </Stack>
  )
}

function DirectChatName({ chat }: Props) {
  const { data: currentUser } = useGetAuthenticatedUser()
  const chatMember = chat.chatMembers.at(0)
  const userId = chatMember?.userId ?? currentUser?.userId
  const personId = chatMember?.personId ?? currentUser?.personId

  return personId ? (
    <PersonLink personId={personId} />
  ) : (
    <PersonNameWithUserNameFallback userId={userId} />
  )
}
